"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.noCreateAllowedFor = void 0;

/**
 * List of modelDefinition names that should not allow create. Even when their schema authorities allows the user
 * to create them, the user should not be allowed to create these objects for some business logic reason.
 *
 * @private
 * @type {Set<string>}
 * @readonly
 */
var noCreateAllowedFor = new Set([// Creating categoryOptionCombos is not allowed because they are generated by the backend.
'categoryOptionCombo']);
/**
 * Default options to be used when running the `d2.init` function.
 */

exports.noCreateAllowedFor = noCreateAllowedFor;
var _default = {
  baseUrl: '/api',
  i18n: {
    sources: new Set(),
    strings: new Set()
  }
};
exports.default = _default;
//# sourceMappingURL=defaultConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/defaultConfig.js
// module id = 595
// module chunks = 0